import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { entAnimations } from 'src/app/animations';
import { RouteStatusService } from 'src/app/services/maintenance/route-status.service';
import { Error } from 'src/app/models/error.model';
import { UsersService } from 'src/app/services/users/users.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class StartComponent implements OnInit {
  startForm: FormGroup;
  localuser = { username: '', activationCode: '' };
  error: Error = { error: { message: '', code: '' } };
  submitted = false;
  starterror = false;
  maxlength = 50;
  isBusy = false;
  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };
  private subscription: Subscription = new Subscription();

  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UsersService,
    private router: Router,
    private _routeStatusService: RouteStatusService
  ) {
    // reset login status
    this._userService.emptyStorage();
  }

  ngOnInit(): void {
    //check if maintenance
    // Maintenance mode settings
    const urls = ['/start'];
    this.subscription.add(
      this._routeStatusService
        .getRouteStatusForUrls(urls)
        .subscribe(statuses => {
          if (statuses['/start']) {
            this.router.navigate(['/errors/error-maintenance']); // Redirect in case of maintenance
          }
        })
    );

    this.startForm = this._formBuilder.group({
      username: ['', [Validators.required, Validators.minLength(5)]],
      activationCode: ['', [Validators.required, Validators.minLength(5)]],
    });
  }

  RedirectToFaq(): void {
    window.open(
      'https://support.ictvs.ch/index.php/fr/eduid',
      '_blank' // <- This is what makes it open in a new window.
    );
  }

  async start(): Promise<void> {
    this.isBusy = true;
    this.submitted = true;
    this.starterror = false;
    try {
      this.localuser.username = this.startForm.get('username').value;
      this.localuser.activationCode =
        this.startForm.get('activationCode').value;
      await lastValueFrom(
        this._userService.startActivation(
          this.localuser.username,
          this.localuser.activationCode
        )
      );
      this.router.navigate(['/validation']);
      this.submitted = true;
    } catch (error) {
      if (error.statusText == 'Unknown Error') {
        this.error = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          this.error = error.error;
        } else {
          this.error = {
            error: {
              message: 'Username or password is incorrect',
              code: 'ERR2',
            },
          };
        }
      }

      this.starterror = true;
      this.submitted = false;
      this.isBusy = false;
    } finally {
      this.isBusy = false;
      this.submitted = true;
    }
  }
}
